var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoConferencing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.88 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_2",
    "data-name": "\\u5716\\u5C64 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_1-2",
    "data-name": "\\u5716\\u5C64 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.42,2.18A1.28,1.28,0,0,1,40.7,3.46V29.11a1.28,1.28,0,0,1-1.28,1.27h-36a1.27,1.27,0,0,1-1.28-1.27V3.46A1.28,1.28,0,0,1,3.46,2.18h36m0-2.18h-36A3.46,3.46,0,0,0,0,3.46V29.11a3.46,3.46,0,0,0,3.46,3.45h36a3.46,3.46,0,0,0,3.46-3.45V3.46A3.46,3.46,0,0,0,39.42,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.89,
    y: 33.82,
    width: 11.09,
    height: 2.33,
    rx: 0.28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.88,40H9a2.33,2.33,0,0,1,2.34-2.33H31.55A2.33,2.33,0,0,1,33.88,40Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.36,4.36H5.82A1.28,1.28,0,0,0,4.54,5.64V26.71A1.28,1.28,0,0,0,5.82,28H25.36a1.27,1.27,0,0,0,1.27-1.28V5.64A1.27,1.27,0,0,0,25.36,4.36Zm-9.77,3.7a3.72,3.72,0,1,1-3.72,3.72A3.72,3.72,0,0,1,15.59,8.06Zm6.56,14.37a1.16,1.16,0,0,1-.87,1.11,21.39,21.39,0,0,1-5.69.75,21.41,21.41,0,0,1-5.7-.75A1.16,1.16,0,0,1,9,22.43H9a6.56,6.56,0,1,1,13.12,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.91,4.36H28.64A.6.6,0,0,0,28,5V15a.61.61,0,0,0,.61.61h9.27a.6.6,0,0,0,.6-.61V5A.6.6,0,0,0,37.91,4.36ZM33.27,6.62A1.48,1.48,0,1,1,31.79,8.1,1.48,1.48,0,0,1,33.27,6.62Zm2.61,5.94a.47.47,0,0,1-.34.45A8.74,8.74,0,0,1,31,13a.47.47,0,0,1-.34-.45h0a2.61,2.61,0,1,1,5.22,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.91,16.78H28.64a.61.61,0,0,0-.61.61v10a.61.61,0,0,0,.61.61h9.27a.6.6,0,0,0,.6-.61v-10A.6.6,0,0,0,37.91,16.78ZM33.27,19a1.48,1.48,0,1,1-1.48,1.48A1.48,1.48,0,0,1,33.27,19ZM35.88,25a.46.46,0,0,1-.34.44,8.74,8.74,0,0,1-4.54,0,.46.46,0,0,1-.34-.44h0a2.61,2.61,0,0,1,5.22,0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoConferencing);
export default __webpack_public_path__ + "static/media/videoConferencing.b558f70b675af3d7700b72e229c28175.svg";
export { ForwardRef as ReactComponent };